import React from "react";
import styled from "styled-components";
import { Viewer } from "@toast-ui/react-editor";
import Button from "../../components/common/Button";
import { useNavigate } from "react-router-dom";
import Body from "../../components/common/Body";

function Privacy() {
  const navigate = useNavigate();
  const base =
    "\n" +
    "          1. 주식회사 에프엔에프 (“http://www.fnf.co.kr”)는 F&F 모바일 VMD 앱 이용자의 개인정보를 매우 중요하게 생각하며 각별히 주의를 기울여 처리하고 있습니다.\n" +
    "          다음과 같은 목적외에는 사용하지 않습니다.\n" +
    "          – android.permission.CAMERA : 해당 휴대폰에서 촬영된 사진을 이용해 VMD 요청 사진을 변경하기 위함.\n" +
    "\n" +
    "          2. 정보 주체의 권리, 의무 및 그 행사방법 이용자는 개인정보 주체로서 다음과 같은 권리를 행사할 수 있습니다.\n" +
    "\n" +
    "          ① 정보주체는 주식회사 에프엔에프( ‘http://www.fnf.co.kr’ ) 에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.\n" +
    "          1) 개인정보 열람요구\n" +
    "          2) 오류 등이 있을 경우 정정 요구\n" +
    "          3) 삭제요구\n" +
    "          4) 처리정지 요구\n" +
    "          * 에프엔에프는 앱 사용자의 사용정보를 수집 및 보유하지 않습니다.\n" +
    "\n" +
    "          3. 처리하는 개인정보의 항목 작성\n" +
    "          ① 에프엔에프는 다음의 개인정보 항목을 처리하고 있습니다.\n" +
    "          1) < VMD 요청 하기 위한 카메라의 연동 >\n" +
    "          – 필수항목 android.permission.CAMERA\n" +
    "          단순히, VMD 요청을 위한 용도로만 사용합니다. 그 외의 어떠한 자료도 수집 및 처리하지 않습니다.\n" +
    "\n" +
    "          4. 개인정보의 파기\n" +
    "          에프엔에프는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체없이 해당 개인정보를 파기합니다. 파기의 절차, 기한 및 방법은 다음과 같습니다.\n" +
    "          – 사용 되는 개인정보는 프로필 사진을 변경하는 용도로만 이용됩니다.\n" +
    "          – 위 한가지 외에는 어떤 목적으로도 자료를 수집, 처리하지 않습니다.\n" +
    "          – 앱 삭제시 더 이상 위 권한을 사용하지 않습니다.\n" +
    "\n" +
    "          5. 개인정보의 안정성 확보 조치\n" +
    "          에프앤에프는 개인정보보호법 제29에 따라 다음과 같이 안정성 확보에 필요한 기술적/관리적 및 물리적 조치를 하고 있습니다.\n" +
    "          ① 내부관리계획의 수립 및 시행\n" +
    "          – 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.\n" +
    "          ② 개인정보에 대한 접근 제한\n" +
    "          – 개인정보를 처리하는 데이터베이스시스템에 대한 접근권한의 부여,변경,말소를 통하여 개인정보에 대한 접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있습니다.\n" +
    "          ③ 비인가자에 대한 출입 통제\n" +
    "          – 출입통제 절차를 수립 및 운영하고 있습니다.\n" +
    "\n" +
    "          6. 개인정보 보호책임자 작성\n" +
    "          ① 에프엔에프는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.\n" +
    "          ▶ 개인정보 보호책임자 및 담당부서\n" +
    "          성명 : 권순욱\n" +
    "          담당부서 : 경영기획 부문\n" +
    "          연락처 : swk@fnf.co.kr, 02-520-0111\n" +
    "\n" +
    "          ② 정보주체께서는 에프엔에프의 서비스를 이용 하시면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 에프엔에프는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.\n" +
    "\n" +
    "          7. 개인정보 처리방침 변경\n" +
    "          ① 이 개인정보 처리 방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.\n" +
    "          이 개인정보 처리방침은 2018년 1월 8일 부터 적용됩니다.\n";

  const ugc =
    "          UGC는 이용자가 스스로 작성하거나 업로드한 콘텐츠로, 저작권 등의 법적 보호를 받을 수 있습니다.\n" +
    "          따라서 이용자는 자신이 작성한 UGC에 대한 모든 권리와 책임을 가지게 됩니다.\n" +
    "          이용자는 UGC를 작성할 때 타인의 지적재산권을 침해하지 않도록 주의해야 합니다.\n" +
    "\n" +
    "          UGC 이용에 대한 권리와 책임\n" +
    "          이용자는 UGC를 사용하거나 게시물을 열람할 때, 해당 콘텐츠의 저작권 등의 법적 보호를 준수해야 합니다.\n" +
    "          UGC를 이용하여 상업적 목적으로 이용하는 경우, 해당 UGC를 작성한 이용자로부터 사전에 동의를 받아야 합니다.\n" +
    "          UGC를 이용하여 법적 분쟁이 발생할 경우, 해당 분쟁에 대한 책임은 이용자가 부담하게 됩니다.\n" +
    "\n" +
    "          UGC 관리에 대한 권리와 책임\n" +
    "          UGC를 운영하는 서비스 제공자는 UGC 내용을 검열하거나 삭제하는 권리와 책임을 가지고 있습니다.\n" +
    "          이용자가 작성한 UGC가 타인의 지적재산권을 침해하는 경우, 서비스 제공자는 해당 UGC를 삭제할 수 있습니다.\n" +
    "          서비스 제공자는 이용자가 작성한 UGC를 저장, 복제, 전송할 수 있는 권리와 책임을 가지며, 이는 서비스 운영에 필요한 경우에 한해 적용됩니다.\n" +
    "\n" +
    "          UGC 이용약관의 변경\n" +
    "          서비스 제공자는 필요에 따라 UGC 이용약관을 변경할 수 있습니다.\n" +
    "          UGC 이용약관이 변경될 경우, 변경 사항을 이용자에게 공지하고, 변경된 약관에 동의하지 않을 경우 해당 이용자는 서비스 이용을 중단할 수 있습니다.";

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            이용약관/사용자 정책
          </Button>
        </div>
      </header>

      <Body>
        <PrivacyBox>
          <p className="title">F&F VMD 앱 개인정보 처리 방침</p>
          <Viewer initialValue={base} />

          <p className={"title"}>UGC에 대한 권리와 책임</p>
          <Viewer initialValue={ugc} />
        </PrivacyBox>
      </Body>
    </>
  );
}

const PrivacyBox = styled.div`
  padding: 20px 15px 40px;
  .category {
    margin-bottom: 8px;
    color: ${({ theme }) => theme.color.tertiary};
    font-size: 12px;
  }
  .title {
    margin-bottom: 16px;
    color: #000;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    word-break: break-all;
    > img {
      margin-left: 4px;
    }
  }
  .content {
    margin-bottom: 40px;
    word-break: break-word;
    white-space: pre-wrap;
    ${/* 에디터 뷰영역 리셋 초기화 */ ""}
    .h1 {
      font-size: 24px !important;
    }
    .h2 {
      font-size: 22px;
    }
    .h3 {
      font-size: 20px;
    }
    .h4 {
      font-size: 18px;
    }
    .h5 {
      font-size: 16px;
    }
    .h6 {
      font-size: 14px;
    }
    strong {
      font-weight: bold;
    }
    em {
      font-style: italic;
    }
  }
  .file-list {
    > p {
      display: inline-block;
      height: 20px;
      padding: 0 6px;
      border: 1px solid #000;
      border-radius: 10px;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
    }
    > ul {
      padding: 8px 0 24px;
      > li {
        ${({ theme }) => theme.flexBox.flexMixin()}
        padding: 6px;
        margin-top: 8px;
        border: 1px solid ${({ theme }) => theme.color.linePrimary};
        color: ${({ theme }) => theme.color.tertiary};
        &:first-child {
          margin-top: 0;
        }
        .file-name {
          flex-grow: 1;
          ${({ theme }) => theme.textOverflow.singleLine()}
        }
        .file-size {
          position: relative;
          flex-grow: 0;
          padding-left: 16px;
          margin-left: 16px;
          color: ${({ theme }) => theme.color.quaternary};
          &:before {
            position: absolute;
            left: 0;
            content: "";
            display: block;
            width: 2px;
            height: 16px;
            background-color: ${({ theme }) => theme.color.lineSecondary};
          }
        }
        button {
          flex-grow: 0;
          margin-left: 16px;
        }
      }
    }
  }
  .name {
    padding-right: 16px;
    color: ${({ theme }) => theme.color.secondary};
  }
  .date {
    color: ${({ theme }) => theme.color.tertiary};
  }
  .end-date {
    padding-left: 8px;
    margin: 8px 0 0 8px;
    border-left: 2px solid ${({ theme }) => theme.color.lineSecondary};
    color: ${({ theme }) => theme.color.warning};
    font-weight: 500;
  }
`;
export default Privacy;
